export let colors = {
  planning: '#00b0f0',
  lineSearch: '#013e7d',
  red: '#e00000',
  faintred: '#ff7070',
  blue: '#0000ff',
  fullgreen: '#00ff00',
  darkgreen: '#004000',
  green: '#009000',
  darkred: '#500000',
  darkblue: '#000050',
  midgrey: '#a0a0a0',
  darkgrey: '#606060',
  black: '#000000',
  orange: '#FF844E',
  white: '#ffffff',
  standard: ['c00000', 'ff0000', 'ffc000', 'ffff00', '92d050', '00b050', '00b0f0', '0070c0', '0000ff', '7030a0'],
};
export let state = {
  rad: 1,
  lsrad: 0,
  callingInsight: false,
  sidebarWidth: 250,
  progressMinimized: false,
  noInfoPopup: false,
  planningActive: false,
  lineSearchAction: false,
  currentColor: colors.red,
  currentBM: 'mmLayer',
  siteBusy: false,
  hasWFS: 0,
  hasProxy: 0,
  hasFind: 0,
  marker2: null,
  overStatus: false,
  markerLocation: null,
  lastEvent: null,
  fillOn: false,
  multiTitle: false,
  currentLocation: {},
  restrictTitleNumbersLevel: 7,
  titleNumbersChecked: false,
  polysel: false,
  modified: false,
  moving: false,
  currentLR: null,
  snapsSeen: false,
  usePlanSeen: false,
  getting: false,
  snapActive: false,
  selectActive: false,
  modifyActive: false,
  noDup: false,
  lastIntersect: [],
  seenItems: [],
  planningResults: [],
  planningPoly: '',
  planningCenter: null,
  lineSearchResults: [],
  lineSearchPoly: '',
  lineSearchCenter: null,
  infoClosed: false,
  UISession: {},
  curXY: null,
  curMouseXY: null,
  curKey: null,
  labelPoint: null,
  lastEditMode: '',
  latestFeature: [],
  latestFeaturePos: 0,
  lastMode: null,
  images: [],
  currentCursor: 'default',
  usePlan: false,
  info_timer: null,
  selectTimer: null,
  query_active: false,
  savedFeatures: [],
  selectedFeature: null,
  currentFeature: null,
  clickedFeature: null,
  clickedFeatures: [],
  snapFeatures: [],
  multi_uprn: false,
  infoActive: false,
  drawActive: false,
  boundaryActive: false,
  shiftDown: false,
  initcol: null,
  mousePos: null,
  planningOn: false,
  lineSearchOn: false,
  heldJSON: '',
  csvArray: [],
  fillHistoryPointer: -1,
  fillFeaturesL: null,
  fillHistory: [],
  annotation: null,
  initx: 532609.734270006,
  inity: 179542.686010996,
  overcount: 0,
  client: null,
  timer: null,
  wfsTimer: null,
  frozen: false,
  sendImageTimeout: null,
  lrwasChecked: [],
  snapshotFeatures: [],
  addedSnapshotFeatures: [],
  updatedData: [],
  snapshotLayers: [],
  snapshotGroups: [],
  allPrice: 0,
  planningClicked: false,
  lineSearchClicked: false,
  polysearch: null,
  polysearchSelected: null,
  polysearchModified: false,
  titlesOn: false,
  lses: null,
  prevZoom: 5,
  storeSessionTimer: null,
  finalWKT: null,
  finalCentroid: null,
  finalArea: null,
  finalJSONString: null,
  uncleanJSONString: null,
  confirmed_address: '',
  snapsAddressString: '',
  panorama: null,
  sv_dragged: false,
  startzoom: 11,
  loadcount: 0,
  toids: [],
  lcheck: 10,
  oscheck: 7,
};
